import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import fxViewcomponents from '@/components/fxView' 
//====================bank==================================================
import bank from '@/components/fxView/bank/bank'
//====================users=================================================
import landingPage from '@/components/fxView/lp/demo-account'
import login from '@/components/fxView/users/login'
import register from '@/components/fxView/users/register'
import twoFa from '@/components/fxView/users/2FA'
import profile from '@/components/fxView/users/profile'

import forgotPassword from '@/components/fxView/users/forgot_password'
import notification from '@/components/fxView/users/user_notification'
import ResetPasswordFromHash from '@/components/fxView/users/ResetPasswordFromHash'
import request_verify from '@/components/fxView/users/request_verify'
import dashboard from '@/components/fxView/users/dashboard'
import changeUserPassword from '@/components/fxView/users/change_password'
import welcome from '@/components/fxView/users/welcome'
//======================trading account=====================================
import later from '@/components/fxView/registerSteps/do_later'
import openOrderList from '@/components/fxView/tradingAccounts/open_orders_listing'
import openTradeList from '@/components/fxView/tradingAccounts/open_trades_listing'
import closeTradeList from '@/components/fxView/tradingAccounts/close_trades_listing'
import createAccountLive from '@/components/fxView/tradingAccounts/create_account_live'
import createAccountDemo from '@/components/fxView/tradingAccounts/create_account'
import create_zulu_account from '@/components/fxView/tradingAccounts/create_zulu_account'
import rest_api from '@/components/fxView/tradingAccounts/rest_api'

import web_trade_link from '@/components/fxView/tradingAccounts/web_trade_link'
import web_trade_link_live from '@/components/fxView/tradingAccounts/web_trade_link_live'
import new_web_trade_link from '@/components/fxView/tradingAccounts/web_trade_link_new'
import createSubTicket from '@/components/fxView/tradingtools/createSubTicket'


//======================manage account=====================================

import accountVerify from '@/components/fxView/manageAccounts/account-verify'
import detach_account from '@/components/fxView/manageAccounts/detach_account'
//=====================deposit================================================
import depositTransaction from '@/components/fxView/deposit/deposit_transaction'
//=====================Bonus================================================

import bonusVerify from '@/components/fxView/bonus/bonus_verify'
import loyaltyVerify from '@/components/fxView/wallet/loyality/loyalty-verify'
//=====================supports================================================


import unauthorized from '@/components/fxView/unauthorized/unauthorized'
import pendingVerification from '@/components/fxView/unauthorized/pending_verification'

//=====================tradinngTools page================================================
import api_documentation from '@/components/fxView/tradingtools/api_documentation'
import subscription_verify from '@/components/fxView/tradingtools/subscription_verify'

import wallet from '@/components/fxView/wallet/wallet'

import nuvei from '@/components/fxView/deposit/nuvei'

//========================register-steps===================================================

import steps from '@/components/fxView/registerSteps/steps'
import step_one from '@/components/fxView/registerSteps/step1'
import step_two from '@/components/fxView/registerSteps/step2'
import step_three from '@/components/fxView/registerSteps/step3'
import step_four from '@/components/fxView/registerSteps/step4'
import step_five from '@/components/fxView/registerSteps/step5'



import subsTransactionDetail from '@/components/fxView/tradingtools/subsTransactionDetail'
import sub_change_account from '@/components/fxView/tools/pages/sub_change_account'
import sub_change_account_verify from '@/components/fxView/tools/pages/sub_change_account_verify'

import unsubscribe_plan from '@/components/fxView/tools/pages/unsubscribe_plan'
import unsubscribe_verify from '@/components/fxView/tools/pages/unsubscribe_verify'





import accountfunding from '@/components/fxView/wallet/account-funding'   //this includes depsit-add/list and withdrawal - add/list pages


import account from '@/components/fxView/account/account' // account list , change-pasword internal transfer , change-leverage
import accountList from '@/components/fxView/manageAccounts/account_list'
import changeLeverage from '@/components/fxView/manageAccounts/change_leverage'
import internalTransfer from '@/components/fxView/manageAccounts/internal_transfer'
import changePassword from '@/components/fxView/manageAccounts/change_password1'


import deposit_bonus from '@/components/fxView/bonus/deposit_bonus'

import social_trade from '@/components/fxView/socialTrade/social_trade'

import tools from '@/components/fxView/tools/tools'

import research_and_education from '@/components/fxView/research/research_and_education'

import downloadplatform from '@/components/fxView/users/downloadplatform'

import support from '@/components/fxView/supports/index'
import view from '@/components/fxView/supports/view'

import refer_a_friend from '@/components/fxView/users/refer-a-friend'
import paymentCallback from '@/components/fxView/deposit/paymentCallback'


import {BANK,DASHBOARD,PROFILE,TWOFA,REQUEST_VERIFY,INDEX,NOTIFICATION,TRADER_CHANGE_PASSWORD,ACCOUNT_LIST,OPEN_TRADES,OPEN_ORDERS,WITHDRAWAL,WITHDRAWAL_LIST,DEPOSIT,DEPOSIT_LIST,BONUS,BONUS_LIST,REMOVE_BONUS,SUPPORT,VIEW,CHANGE_LEVERAGE,
INTERNAL_TRANSFER,ACCOUNT_VERIFY,LS_ROUTE_KEY,CREATE_DEMO_ACCOUNT,CREATE_LIVE_ACCOUNT} from "@/consts"
Vue.use(Router)

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}


const router =  new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'fxView.login', component: login },
    { path: '/register', name: 'fxView.register', component: register },
    { path: '/forgot-password', name: 'fxView.forgotPassword', component: forgotPassword },
    { path: '/forgot/password/:hash', name: 'fxView.ResetPasswordFromHash', component: ResetPasswordFromHash },
    { path: '/lp/insights', name: 'fxView.landingPage', component: landingPage },
    {
      path: '/',
      component:fxViewcomponents,
      children: [
      {path: '/wallet',name: 'wallet',component: wallet},
      {path: '/nuvei',name: 'nuvei',component: nuvei},
      {path: '/account-funding',name: 'accountfunding',component: accountfunding},
      {path: '/detach-account',name: 'detach_account',component: detach_account},
      {path: '/research-and-education/:tabName',name: 'research_and_education',component: research_and_education},
      {path: '/social-trade',name: 'social_trade',component: social_trade},
      {path: '/tools/:tabName',name: 'tools',component: tools},
      {path: '/deposit-bonus',name: 'deposit_bonus',component: deposit_bonus},
        { path: '/vps-subscription-verify', name: 'fxView.subscription_verify', component: subscription_verify },
        //====================bank=================================================
        { path: BANK, name: 'fxView.bank', component: bank },
        { path: '/pending', name: 'fxView.later', component: later },
        //====================users=================================================
        { path: DASHBOARD, name: 'fxView.dashboard', component: dashboard },
        { path: '/change-password', name: 'fxView.changeUserPassword', component: changeUserPassword },
        { path: '/subscription-detail', name: 'fxView.subsTransactionDetail', component: subsTransactionDetail, props : true },
        { path: PROFILE, name: 'fxView.profile', component: profile },
        { path: '/download-platform', name: 'fxView.downloadplatform', component: downloadplatform },
        { path: TWOFA, name: 'fxView.twoFa', component: twoFa },
        { path: NOTIFICATION, name: 'fxView.notification', component: notification },
        { path: REQUEST_VERIFY, name: 'fxView.request_verify', component: request_verify, props : true },
        { path: '/index', name: 'fxView.welcome', component: welcome },
        //======================manage account=====================================
        { path: '/account', name: 'account', component: account },
        { path: TRADER_CHANGE_PASSWORD, name: 'fxView.changePassword', component: changePassword },
        { path: CHANGE_LEVERAGE, name: 'fxView.changeLeverage', component: changeLeverage },
        { path: INTERNAL_TRANSFER, name: 'fxView.internalTransfer', component: internalTransfer },
        { path: ACCOUNT_LIST, name: 'fxView.accountList', component: accountList },
        { path: ACCOUNT_VERIFY, name: 'fxView.accountVerify', component: accountVerify },
        //======================trading account=====================================
        { path: OPEN_TRADES, name: 'fxView.openTradeList', component: openTradeList },
        { path: '/close-trades', name: 'fxView.closeTradeList', component: closeTradeList },
        { path: '/rest-api', name: 'fxView.rest_api', component: rest_api },
        { path: '/web-trade-link', name: 'fxView.web_trade_link', component: web_trade_link },
        { path: '/new-web-trade-link', name: 'fxView.new_web_trade_link', component: new_web_trade_link },
        { path: '/web-trade-link-live', name: 'fxView.web_trade_link_live', component: web_trade_link_live },
        { path: OPEN_ORDERS, name: 'fxView.openOrderList', component: openOrderList },
        { path: CREATE_LIVE_ACCOUNT, name: 'fxView.createAccountLive', component: createAccountLive },
        { path: CREATE_DEMO_ACCOUNT, name: 'fxView.createAccountDemo', component: createAccountDemo },
        { path: '/create-zulu-account', name: 'fxView.createZuluAccount', component: create_zulu_account },
        { path: '/transaction-history', name: 'fxView.depositTransaction', component: depositTransaction },
        //=====================bonus===============================================
        { path: '/bonus-verify', name: 'fxView.bonusVerify', component: bonusVerify },  
        { path: '/loyalty-verify', name: 'fxView.loyaltyVerify', component: loyaltyVerify },
        //=====================supports============================================
        { path: SUPPORT, name: 'fxView.support', component: support },
        {  path: '/create-subscription-ticket',  name: 'fxView.createSubTicket',  component: createSubTicket  },
        { path: VIEW, name: 'fxView.view', component: view },
        { path: '/unauthorized', name: 'fxView.unauthorized', component: unauthorized },
        { path: '/pending-verification', name: 'fxView.pendingVerification', component: pendingVerification },
        //=====================Market subscription============================================
        { path: '/api-documentation', name: 'fxView.api_documentation', component: api_documentation },
        { path: '/refer-a-friend', name: 'fxView.refer_a_friend', component: refer_a_friend },
        { path: '/subscription-change-account', name: 'fxView.sub_change_account', component: sub_change_account },
        { path: '/subscription-account-verify', name: 'fxView.sub_change_account_verify', component: sub_change_account_verify },
        { path: '/unsubscribe-plan', name: 'fxView.unsubscribe_plan', component: unsubscribe_plan },
        { path: '/unsubscribe-verify', name: 'fxView.unsubscribe_verify', component: unsubscribe_verify },
        { path: '/paymentCallback', name: 'fxView.paymentCallback', component: paymentCallback },
        //========================register-steps=================================================
        {
          path : '',
          component : steps,
          children:[
            { path: '/step1', name: 'fxView.step_one', component: step_one },
            { path: '/step2', name: 'fxView.step_two', component: step_two },
            { path: '/step3', name: 'fxView.step_three', component: step_three },
            { path: '/step4', name: 'fxView.step_four', component: step_four },
            { path: '/step5', name: 'fxView.step_five', component: step_five }
          ]
        }
      ]
    },
    { path: "/*", redirect: "/" }
  ]
})

router.beforeEach((to, from, next) => {

  if(!hasQueryParams(to) && hasQueryParams(from)){
    window.fz("event", {name: "pageView", value: window.location.hostname+to.path, unit: "url"});
  }else {
    window.fz("event", {name: "pageView", value: window.location.hostname+to.path, unit: "url"});
  }

  let userStateVariable = store.state.user
  if(userStateVariable == ''){
    userStateVariable= {}
  }
  if (to.name !== 'fxView.login' && to.name !== 'fxView.register' && to.name !== 'fxView.forgotPassword' && to.name !== 'fxView.ResetPasswordFromHash' && to.name !== 'fxView.landingPage' && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)) {
        localStorage.setItem("lastPath", to.path);
        // console.log('=======query',to.query)
        if(to.query.ticketData){
            localStorage.setItem("query", to.query.ticketData);
        }
        /*if(to.query.auth){
            localStorage.setItem("temp_token", to.query.auth);
        }*/
        next({ name: 'fxView.login' })
  }
  //if the user is not authenticated, `next` is called twice
  //else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && (to.name == 'fxView.createAccountLive') && parseInt(userStateVariable.verified_status) != 1) next({ name: 'fxView.dashboard' })

  else if ((to.name == 'fxView.step_one' || to.name == 'fxView.step_two' || to.name == 'fxView.step_three' || to.name == 'fxView.step_four' || to.name == 'fxView.step_five') && ((userStateVariable != null || 'loggedIn' in userStateVariable) || userStateVariable.loggedIn) && (parseInt(userStateVariable.step) >= 5)) next({ name: 'fxView.dashboard' })

  else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn  && (to.name == 'fxView.login' || to.name == 'fxView.register' || to.name == 'fxView.forgotPassword' || to.name == 'fxView.ResetPasswordFromHash' || to.name == 'fxView.landingPage')) next({ name: 'fxView.dashboard' })

  else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && (to.name == 'fxView.login' || to.name == 'fxView.register' || to.name == 'fxView.forgotPassword' || to.name == 'fxView.ResetPasswordFromHash' || to.name == 'fxView.landingPage')) next({ name: 'fxView.dashboard' })
  
  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js